import { render, staticRenderFns } from "./EmpTable.vue?vue&type=template&id=69720d82&scoped=true&"
import script from "./EmpTable.vue?vue&type=script&lang=js&"
export * from "./EmpTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69720d82",
  null
  
)

export default component.exports